import { useState } from "react"

export default function GiftBox({
    onClick,
    selectedPrize = null,
    prize = null
}) {

    const [isHovered, setIsHovered] = useState(false);
    const [open, setOpen] = useState(false);

    const baseSize = 80;
    const lidSize = baseSize * 1.1;

    const faceClass = `absolute w-[${baseSize}px] h-[${baseSize}px] z-[1] shadow-[inset_0_0_${baseSize / 10}px_${baseSize / 10}px_#0002]`;

    const handleClick = () => {
        onClick();

        if (selectedPrize) return;

        setOpen(true);
    }

    const renderLid = () => {
        const offsets = {
            open: baseSize * 2,
            hovered: baseSize * 1,
            closed: baseSize * 0.75,
        }

        const offset = offsets[open ? 'open' : isHovered ? 'hovered' : 'closed'];

        return (
            <div
                className="absolute"
                style={{
                    height: `${lidSize}px`,
                    width: `${lidSize}px`,
                    transformStyle: 'preserve-3d',
                    zIndex: 2,
                    transform: `translateZ(${offset}px)`,
                    transition: 'transform 0.3s ease-out',
                }}
            >
                {/* Lid Top Face */}
                <div
                    className={`${faceClass} bg-primary`}
                    style={{
                        zIndex: 2,
                        width: `${lidSize}px`,
                        height: `${lidSize}px`,
                        backgroundImage: 'linear-gradient(to right, transparent 33%, #eab308 34% 65%, #0002 66% 68%, transparent 69%), linear-gradient(to top, transparent 33%, #eab308 34% 65%, transparent 66%)',
                    }}
                />

                {/* Lid Left Face */}
                <div
                    className={`${faceClass} bg-primary`}
                    style={{
                        zIndex: 2,
                        width: `${lidSize}px`,
                        height: `${baseSize / 2}px`,
                        transform: `rotateX(-90deg) translateZ(${lidSize}px)`,
                        backgroundImage: 'linear-gradient(to right, transparent 33%, #eab308 34% 65%, transparent 66%)',
                        transformOrigin: 'top',
                    }}
                />

                {/* Lid Right Face */}
                <div
                    className={`${faceClass} bg-primary`}
                    style={{
                        zIndex: 2,
                        width: `${baseSize / 2}px`,
                        height: `${lidSize}px`,
                        transformOrigin: 'left',
                        transform: `rotateY(90deg) translateZ(${lidSize}px)`,
                        backgroundImage: 'linear-gradient(to top, transparent 33%, #eab308 34% 65%, transparent 66%)'
                    }}
                />

                {/* Ribbon */}
                <div
                    className="absolute bg-yellow-500"
                    style={{
                        width: `${baseSize / 2}px`,
                        height: `${baseSize / 2}px`,
                        transform: `translateZ(1px) translateX(50%) translateY(50%)`,
                        transformStyle: 'preserve-3d',
                    }}
                >
                    {Array.from(new Array(8)).map((_, index) => (
                        <div
                            key={index}
                            style={{
                                position: 'absolute',
                                width: '100%',
                                height: '50%',
                                top: '50%',
                                left: 0,
                                transformOrigin: '50% 0%',
                                backgroundColor: '#eab308',
                                borderRadius: 9999,
                                filter: `brightness(${index / 10 + 0.4})`,
                                transform: `rotateX(90deg) rotateY(${360 / 8 * index}deg)`

                            }}
                        />
                    ))}
                </div>

            </div>
        )
    }

    return (
        <div
            className={`relative w-[${baseSize * 1.6}px] h-[${baseSize * 2}px]`}
            style={{
                filter: !!selectedPrize && selectedPrize?.key !== prize?.key ? 'grayscale(100%)' : 'none'
            }}
        >
            <div
                className={`absolute w-[${baseSize}px] h-[${baseSize}px] left-1/2 top-1/2 z-[1] flex justify-center items-center cursor-pointer`}
                style={{
                    transformStyle: 'preserve-3d',
                    transform: `translateY(-${baseSize * 0.75}px) rotateX(50deg) rotateZ(45deg) ${isHovered ? 'scale(1.05)' : 'scale(1)'}`,
                    transformOrigin: '0% 0%',
                    perspective: '1200px',
                    transition: 'transform 0.3s ease',
                }}
                onMouseEnter={() => !selectedPrize && setIsHovered(true)}
                onMouseLeave={() => !selectedPrize && setIsHovered(false)}
                onClick={handleClick}
            >
                <div className="relative" style={{ transformStyle: 'preserve-3d' }}>

                    {renderLid()}

                    {/* Top Inside Face */}
                    <div
                        className={`${faceClass} bg-black`}
                        style={{
                            transform: `translateZ(${baseSize / 2}px)`,
                            backgroundImage: 'linear-gradient(-90deg, transparent 49%, #376fd0), linear-gradient(0deg, transparent 49%, #376fd0)',
                            boxShadow: `inset 0 0 0 ${baseSize / 12}px #376fd0`
                        }}
                    />

                    {/* Left Face */}
                    <div
                        className={`${faceClass} bg-primary`}
                        style={{
                            transform: `rotateX(-90deg) translateZ(${baseSize / 2}px)`,
                            backgroundImage: 'linear-gradient(to right, transparent 33%, #eab308 34% 65%, transparent 66%)'
                        }}
                    />

                    {/* Right Face */}
                    <div
                        className={`${faceClass} bg-primary`}
                        style={{
                            transform: `rotateY(90deg) translateZ(${baseSize / 2}px)`,
                            backgroundImage: 'linear-gradient(to top, transparent 33%, #eab308 34% 65%, transparent 66%)'
                        }}
                    />

                    {/* Floor */}
                    <div
                        className="absolute"
                        style={{
                            width: `${baseSize * 2}px`,
                            height: `${baseSize * 2}px`,
                            borderRadius: '50%',
                            backgroundImage: `radial-gradient(${isHovered ? '#' : '#0008'}, transparent 66%)`,
                            transform: `translateZ(-${baseSize / 2 + baseSize / 10}px) translateX(-${baseSize / 2}px) translateY(-${baseSize / 2}px)`,
                        }}
                    />

                </div>
            </div>

        </div>
    )
}